import React from 'react';
import { Layout } from 'antd';
import type { BasicProps } from 'antd/es/layout/layout';
import type { ThemeConfig } from 'antd';
import classnames from 'classnames';
import cn from './styles.module.scss';
import { ThemeProvider } from '../../theme/provider';

export interface HeaderProps extends BasicProps {
  theme?: ThemeConfig;
  children?: React.ReactNode;
}

const defaultHeaderTheme = {
  components: {
    Avatar: {
      groupBorderColor: 'var(--bc-color-primary)',
      colorTextLightSolid: 'var(--bc-color-text-label)',
    },
  }
}

export const Header = ({ className, children, theme = defaultHeaderTheme, ...rest }: HeaderProps) => {
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Layout.Header className={classnames(cn.header, className)} {...rest}>
          {children}
        </Layout.Header>
      </Layout>
    </ThemeProvider>
  );
};
